"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper Class for various calculations.
 *
 * @class MathUtil
 */
var MathUtil = /** @class */ (function () {
    function MathUtil() {
    }
    /**
     * Converts radians to degrees.
     *
     * @param {number} rad The radian value to convert.
     */
    MathUtil.radToDeg = function (rad) { return rad * 360 / (Math.PI * 2); };
    /**
     * Converts degrees to radians.
     *
     * @param {number} deg The degree value to convert.
     */
    MathUtil.degToRad = function (deg) { return deg * Math.PI * 2 / 360; };
    /**
     * Returns the modulo for (negative) values.
     *
     * @param {number} n The number.
     */
    MathUtil.mod = function (n) { return ((n % (2 * Math.PI)) + (2 * Math.PI)) % (2 * Math.PI); };
    return MathUtil;
}());
exports.default = MathUtil;
